import { ScreeningCheckStatus } from "common/types/services/api/offers/offer-item-dto.type";
import { BackgroundCheckSearchEnum } from "./components/BackgroundCheckReport/background-check-search.enum";
import { CreditCheckResultEnum } from "./components/CreditCheckReport/credit-score-report.types";

export type BackgroundCheckReportDto = {
  evictions: BackgroundCheckSearchEnum;
  offenders: BackgroundCheckSearchEnum;
  watchlist: BackgroundCheckSearchEnum;
  criminals: BackgroundCheckSearchEnum;
}

export type CreditCheckReportDto = {
  name: string
  result: CreditCheckResultEnum;
}

export enum ScreeningStatus {
  Prepared = 'Prepared',
  Pending = 'Pending',
  Completed = 'Completed'
}

export type ApplicantScreeningReportDto = {
  firstName: string;
  lastName: string;
  backgroundCheckResult?: BackgroundCheckReportDto;
  creditCheckResult?: CreditCheckReportDto;
  creditCheckStatus?: ScreeningStatus;
  backgroundCheckStatus?: ScreeningStatus;
  creditScreeningCheckStatus: ScreeningCheckStatus;
  backgroundScreeningCheckStatus: ScreeningCheckStatus;
  isAllRunScreeningAccepted: boolean;
  isTenant: boolean,
}